<div>

  <tabset #staticTabs [ngClass]="{'d-none': !enable}">
    <tab id="GeneralInfo" (selectTab)="onTabClicked($event)" heading="{{'LV2Tabs.GeneralInfo'|translate}}">
      <ng-content select=".General"></ng-content>
    </tab>

    <tab id="FactSheet" (selectTab)="onTabClicked($event)" heading="{{'LV2Tabs.FactSheets'|translate}}" class="fact_tab" *ngIf="fact">
      <app-loading-spinner *ngIf="loadingFactSheets"></app-loading-spinner>
      <div class="list-group" *ngFor="let item of factSheets">
        <a href="{{item.fileUrl}}" target="_blank">
          <app-pdf-url-row>
            <h5 style="color: black">{{ item.title }}</h5>
          </app-pdf-url-row>
        </a>
      </div>
    </tab>

    <tab id="Faq" (selectTab)="onTabClicked($event)" heading="{{'LV2Tabs.FAQ'|translate}}" *ngIf="faq">
      <app-loading-spinner *ngIf="loadingFaq"></app-loading-spinner>
      <div class="faq_tab" *ngFor="let item of FaqData">
        <h5 [innerHTML]="item.question | safeHtml"></h5>
        <p [innerHTML]="item.answer | safeHtml"></p>
      </div>
    </tab>

    <tab id="Forms" (selectTab)="onTabClicked($event)" heading="{{'LV2Tabs.Forms'|translate}}" class="forms_tab" *ngIf="forms">
      <app-loading-spinner *ngIf="loadingForms"></app-loading-spinner>
      <app-form-list [forms]="formDetails"></app-form-list>
    </tab>

    <tab id="Calculators" (selectTab)="onTabClicked($event)" *ngIf="calculators" heading="{{'LV2Tabs.Calculator'|translate}}">
      <ng-content select=".Calculator"></ng-content>
    </tab>

    <tab id="Videos" (selectTab)="onTabClicked($event)" *ngIf="videos" heading="Videos">
      <ng-content select=".Videos"></ng-content>
    </tab>

    <!-- Unique to Disaster Relief Page --------------------------------->
    <tab *ngIf="notices" heading="Notices to property owners" >
      <ng-content select=".Notices"></ng-content>
    </tab>
    <!-- ----------------------------------------------------------------- -->

    <tab id="PastEvents" (selectTab)="onTabClicked($event)" *ngIf="pastEvents" heading="Past Events">
      <ng-content select=".past"></ng-content>
    </tab>

    <tab id="News" (selectTab)="onTabClicked($event)" *ngIf="news" heading="News">
      <ng-content select=".news"></ng-content>
    </tab>
  </tabset>

  <div *ngIf="!enable" style="width: 100%; position: relative; height: 50vh; z-index: 0; background-color: transparent;"
       class="inner-text">
    <ngx-spinner [fullScreen]="false" color="#fff" bdColor="transparent"
                 type="ball-spin-fade-rotating" size="large">

    </ngx-spinner>
  </div>
</div>
